module.exports = __webpack_public_path__ + "static/media/email.de8f5790.svg";